import { apiClient } from '../../../services/api/client';

const BASE = '/api/v1/contacts';

export const contactsAPI = {
  list: (params = {}) => apiClient.get(`${BASE}/`, { params }),
  getById: (contactId) => apiClient.get(`${BASE}/${contactId}`),
  create: (data) => apiClient.post(`${BASE}/`, data),
  update: (contactId, data) => apiClient.put(`${BASE}/${contactId}`, data),
  delete: (contactId) => apiClient.delete(`${BASE}/${contactId}`),
  deactivate: (contactId) => apiClient.post(`${BASE}/${contactId}/deactivate`),
};
